import React from 'react';
import AdSense from 'react-adsense';

import './../css/Footer.css'
import GoogleAd from './GoogleAd';

class Footer extends React.Component{

    constructor(){

        super() 

        this.state = {
            ad: <GoogleAd num={0}/>,
            count: 0
        }
    }

    componentDidMount () {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    render() {
        return (
            <div className='Footer'>
                {this.state.ad}
            </div>
            )
    }
}

export default Footer